
function ConfirmationPopup  (props) {
    const {
    show,
    headingText,
    infoText,
    cancelText,
    submitText,
    onCancel,
    onSubmit,
  } = props;
    return (
        <div className={show ? "modal-overlay" : "display-none"}>
            <div className="approval-modal-content" style={{ height: "auto" }}>
                <span className="close" onClick={() => {onCancel()}}>
                    &times;
                </span>
                <h6 className="modal-header p-2">
                    {headingText}
                </h6>{" "}
                {/* Modal Header */}
                <div className="modal-body p-3">
                    <span>{infoText}</span>
                    <div className="row mt-3">
                        <div>
                            <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">


                                <>
                                    <button type="button" className="btn btn-secondary" onClick={() => onCancel()}>
                                        {cancelText}
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={() => onSubmit()}>
                                        {submitText}
                                    </button>
                                </>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfirmationPopup;